import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {HasUnsavedChanges} from './has-unsaved-changes.interface';
import { PopupService } from '../../../shared/components/popup/popup.service';

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  if (!component.hasUnsavedChanges()) {
    return true;
  }

  const popupService = inject(PopupService);

  const dialogRef = popupService.open<boolean | undefined>({
    title: 'New Translation Quote Request',
    message:
      'You have not submitted the current intake form. The information you provided will not be saved and you will need to complete the form again at another time.\n\nAre you sure you want to exit?',
    cancelLabel: 'No',
    confirmLabel: 'Yes',
  });

  return firstValueFrom(dialogRef.afterClosed()).then((result) => {
    if (result === true) {
      component.discardUnsavedChanges?.();
      return true;
    }
    return false;
  });
};